
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import dynamic from 'next/dynamic';

import { Spinner } from '@/components/shared';
import SeoWrapper from '@/components/seo-wrapper/seo-wrapper';

import { getServerSideProps } from '@/utils/ssr-utils';
import { IPageDefinition } from '@/utils/view-definition.interface';

const Page = dynamic(() => import('@/components/common/common.component').then((module) => module.default), {
  ssr: false,
  loading: () => <Spinner />,
});

export { getServerSideProps };

export default function Home({ viewDefinitionResults, themeTokens }: IPageDefinition) {
  const viewMetaData = viewDefinitionResults?.viewDefinition.viewMetaData;

  return (
    <SeoWrapper seoMetaData={viewMetaData} currentUrlBase={viewDefinitionResults?.currentUrlBase}>
      <Page
        viewDefinition={viewDefinitionResults?.viewDefinition}
        themeTokens={themeTokens ?? undefined}
        pageId={viewDefinitionResults?.pageID}
      />
    </SeoWrapper>
  );
}
